import { HEADER_EXPORT_BOOKAO } from "@/constants/header-export";
import { ExportButton } from "@/features/export/layouts/export-button";
import { useDownloadToCsv } from "@/hooks/use-downalod-to-csv";
import { ConvertStatusById } from "@/utils/convert-status-to-name/convert-status-to-name";
import { useBooking } from "../../../hooks/use-booking";
import { ButtonExportBookingsProps } from "./button-export-bookings.types";

export const ButtonExportBookings = ({
  filters,
  className,
}: ButtonExportBookingsProps) => {
  const { getAllBookings } = useBooking();
  const { handleExport } = useDownloadToCsv({
    exportName: "bookao",
    headerCsv: HEADER_EXPORT_BOOKAO,
  });

  const handleClickExport = async (extension: string) => {
    // Depois de atualizar os filtros, obtenha os dados de bookings
    const bookings = await getAllBookings(filters);

    const convertDataBookings = bookings.map((item: any) => {
      return {
        id: item.id,
        booking_detail: item.booking_detail,
        space_room_name: `${item?.spaces?.name} - ${item.privateRooms?.label}`,
        spentAmmount: item.spentAmmount,
        booking_payout_rate_perc:
          item.bookingAttributes.booking_payout_rate_perc,
        number_members: item.privateRooms?.capacity,
        credits: item.credits,
        company_name: item.companies.name,
        booking_commission_fee: Number(
          item.bookingAttributes.booking_commission_fee,
        ),
        transfer: Number(item.bookingAttributes.booking_payout),
        status: ConvertStatusById({
          status: item.status,
          type: "STATUS_BOOKINGS",
        }).title,
      };
    });

    handleExport({ extension, data: convertDataBookings });
  };

  return (
    <ExportButton
      className={className}
      handleExport={handleClickExport}
      placeholder="Exportar Bookings"
    />
  );
};
